import {
  CustomCalenderInput,
  CustomDropDown,
  CustomInput,
} from "../../../components/Input/input";
import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { MainCard } from "../../../components/Card/Cards";
import { InputSwitch } from "primereact/inputswitch";
import axios from "axios";
import { API_BASE_URL } from "../../../utils/constants";
import { MdDeleteForever } from "react-icons/md";
import { MdAddLocationAlt } from "react-icons/md";
import OwnerOperator from "./OwnerOperator";
export default function DriverInformation({ step, setStep }) {
  const [data, setData] = useState({
    name: "",
    license_number: "",
    license_expiry: "",
    license_class: "",
    license_province: "",
    street_address: "",
    city: "",
    zipcode: "",
    province: "",
    country: "",
    phone_number: "",
    dob: "",
    sin: "",
    addresses_past_3_years: [],
    medical_expiry: "",
    owner_operator: null,

    sex: "",
    marital_status: "",
    number_of_dependents: 0,
  });

  const [multipleAddress, setMultipleAddress] = useState(false);
  const [isOwnerOperator, setOwerOperator] = useState(false);
  const [ownerOperatorData, setOwnerOperatorData] = useState({
    truck_year: "",
    truck_make: "",
    last_annual_inspection: "",
    wsib_number: null,
    alternative_insurance: null,
    denied_to_operate_vehicle: false,
    any_license_suspended: false,
    legal_crossing_us_banned: false,
    fast_card: "No",
    capable_for_manual_labour: "Yes",
  });
  const handleChange = ({ name, value }) => {
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const genderOptions = [
    {
      name: "Male",
      value: "Male",
    },
    {
      name: "Female",
      value: "Female",
    },
    {
      name: "Other",
      value: "Other",
    },
  ];

  const maritalStatus = [
    { name: "Single", value: "Single" },
    { name: "Married", value: "Married" },
    { name: "Separated", value: "Separated" },
    { name: "Divorced", value: "Divorced" },
    { name: "Common Law", value: "Common Law" },
  ];
  useEffect(() => {
    setData((prev) => ({
      ...prev,
      addresses_past_3_years: multipleAddress
        ? [{ address: "", howLong: "" }]
        : [],
    }));
  }, [multipleAddress]);

  useEffect(() => {
    if (isOwnerOperator) {
      setData((prev) => ({ ...prev, owner_operator: ownerOperatorData }));
    } else {
      setData((prev) => ({ ...prev, owner_operator: null }));
    }
  }, [isOwnerOperator, ownerOperatorData]);

  const submitData = async () => {
    try {
      const token = sessionStorage.getItem("token"); // Retrieve token from sessionStorage

      console.log("token", token);
      const response = await axios.post(
        API_BASE_URL + "/api/driver/driver-details",
        { driverDetails: data, authToken: token },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        }
      );
      console.log(response);
      setStep((prev) => prev + 1);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to save information");
    }
  };

  return (
    <MainCard size="container">
      <div className="flex flex-wrap">
        <CustomInput
          label="Driver Name"
          name="name"
          value={data?.name}
          onChange={handleChange}
        />
        <CustomInput
          label="Phone Number"
          name="phone_number"
          value={data?.phone_number}
          onChange={handleChange}
        />
        <CustomInput
          label="SIN#"
          name="sin"
          value={data?.sin}
          onChange={handleChange}
        />
        <CustomDropDown
          label="Sex"
          options={genderOptions}
          placeholder="Select"
          col={6}
          name="sex"
          value={data?.sex}
          onChange={handleChange}
        />
        <CustomDropDown
          label="Marital Status"
          options={maritalStatus}
          placeholder="Select"
          col={6}
          name="marital_status"
          value={data?.marital_status}
          onChange={handleChange}
        />
        <CustomInput
          label="Number of dependents"
          name="number_of_dependents"
          value={data?.number_of_dependents}
          onChange={handleChange}
        />
        <CustomCalenderInput
          label="Date of Birth"
          name="dob"
          value={data?.dob}
          onChange={handleChange}
        />
        <CustomCalenderInput
          label="Medical Expiry"
          name="medical_expiry"
          value={data?.medical_expiry}
          onChange={handleChange}
        />
        <hr className="w-full m-5" />
        <h4 className="w-full">License Details</h4>
        <CustomInput
          label="License Number"
          name="license_number"
          value={data?.license_number}
          onChange={handleChange}
        />

        <CustomInput
          label="License Class"
          name="license_class"
          value={data?.license_class}
          onChange={handleChange}
        />
        <CustomCalenderInput
          label="License Expiry"
          name="license_expiry"
          value={data?.license_expiry}
          onChange={handleChange}
        />
        <CustomInput
          label="License Prov."
          name="license_province"
          value={data?.license_province}
          onChange={handleChange}
        />
        <hr className="w-full m-5" />
        <h4 className="w-full">Address</h4>
        <CustomInput
          label="Street"
          name="street_address"
          value={data?.street_address}
          onChange={handleChange}
        />
        <CustomInput
          label="City"
          name="city"
          value={data?.city}
          onChange={handleChange}
        />
        <CustomInput
          label="Zip/Postal Code"
          name="zipcode"
          value={data?.zipcode}
          onChange={handleChange}
        />
        <CustomInput
          label="Province"
          name="province"
          value={data?.province}
          onChange={handleChange}
        />
        <CustomInput
          label="Country"
          name="country"
          value={data?.country}
          onChange={handleChange}
        />
        <div className="w-full px-2 flex align-items-center gap-3 flex-wrap">
          <p className="col-12 md:col-6">
            Do you have changed address in last 3 years?
          </p>
          <div className="flex align-items-center gap-3">
            <span className={!multipleAddress ? "font-semibold" : ""}>No</span>
            <InputSwitch
              checked={multipleAddress}
              onChange={(e) => setMultipleAddress((prev) => !prev)}
            />
            <span className={multipleAddress ? "font-semibold" : ""}>Yes</span>
          </div>
        </div>
        <div className="w-full">
          {data?.addresses_past_3_years?.map((obj, index) => (
            <div className="flex flex-wrap align-items-center" key={index}>
              <CustomInput
                label="Address"
                value={obj?.address}
                onChange={({ value }) =>
                  setData((prev) => ({
                    ...prev,
                    addresses_past_3_years: prev?.addresses_past_3_years?.map(
                      (item, i) =>
                        i === index ? { ...item, address: value } : item
                    ),
                  }))
                }
              />
              <div className="flex gap-3 col-12 lg:col-6 align-items-center">
                <CustomInput
                  label="How Long"
                  extraClassName={"w-8"}
                  value={obj?.howLong}
                  onChange={({ value }) =>
                    setData((prev) => ({
                      ...prev,
                      addresses_past_3_years: prev?.addresses_past_3_years?.map(
                        (item, i) =>
                          i === index ? { ...item, howLong: value } : item
                      ),
                    }))
                  }
                />
                {data?.addresses_past_3_years?.length > 1 && (
                  <Button
                    severity="danger"
                    icon={<MdDeleteForever />}
                    className="mt-4"
                    onClick={() =>
                      setData((prev) => ({
                        ...prev,
                        addresses_past_3_years:
                          prev?.addresses_past_3_years?.filter(
                            (item, i) => index !== i
                          ),
                      }))
                    }
                  />
                )}
                <Button
                  severity="secondary"
                  icon={<MdAddLocationAlt />}
                  className="mt-4"
                  onClick={() =>
                    setData((prev) => ({
                      ...prev,
                      addresses_past_3_years: [
                        ...prev?.addresses_past_3_years,
                        { address: "", howLong: "" },
                      ],
                    }))
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <hr className="w-full m-5" />
      <h4 className="w-full">Owner Operators</h4>
      <div className="w-full px-2 flex align-items-center gap-3 flex-wrap">
        <p className="col-12 md:col-6">Are you an Owner Operator?</p>
        <div className="flex align-items-center gap-3">
          <span className={!isOwnerOperator ? "font-semibold" : ""}>No</span>
          <InputSwitch
            checked={isOwnerOperator}
            onChange={(e) => setOwerOperator((prev) => !prev)}
          />
          <span className={isOwnerOperator ? "font-semibold" : ""}>Yes</span>
        </div>
      </div>
      {isOwnerOperator && (
        <OwnerOperator
          ownerOperatorData={ownerOperatorData}
          setOwnerOperatorData={setOwnerOperatorData}
        />
      )}
      <div className="flex justify-content-end mt-4 pr-2">
        <Button label="Save & Continue" onClick={submitData} />
      </div>
    </MainCard>
  );
}
